import {
    BottomSheetContent as UiBottomSheetContent,
    IconButton,
    styled,
} from "@l2r-front/l2r-ui"

export const FilledIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette["cta-bg/cta-bg-primary"].main,
    color: "white",
    width: theme.spacing(8),
    height: theme.spacing(8),

    "&:hover": {
        backgroundColor: theme.palette["cta-bg/cta-bg-primary"].dark,
    },
}))

export const BottomSheetContent = styled(UiBottomSheetContent)(() => ({
    flex: 1,
}))